import React, { useState, useRef, useEffect } from "react";
import { Line } from "react-chartjs-2";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TooltipOptions,
    TooltipItem,
} from 'chart.js';

import "./styles.css";
import AnimateHeight from "react-animate-height";
import { BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import { _DeepPartialObject } from "chart.js/types/utils";
import { MensagemGraficoVazio } from "../MensagemGraficoVazio";

interface GraficoLinhaProps {
    tituloGrafico: string,
    labels: string[],
    nomeDado: string,
    corBordaDado?: string,
    corBackgroundDado?: string,
    dadosGrafico: number[],
    setIndexData?: React.Dispatch<React.SetStateAction<number>>,
    tituloTooltip?: string,
    dadoTooltip?: string,
    alturaGrafico?: string,
    graficoPorcentagem?: boolean
}

export const GraficoLinha = ({
    tituloGrafico,
    labels,
    nomeDado,
    corBordaDado,
    corBackgroundDado,
    dadosGrafico,
    setIndexData,
    tituloTooltip,
    dadoTooltip,
    alturaGrafico,
    graficoPorcentagem
}: GraficoLinhaProps) => {

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );

    const [isFullScreen, setIsFullScreen] = useState(false);
    const divRef = useRef(null);

    useEffect(() => {
        if (divRef.current) {
            const canvas = divRef.current.querySelector('canvas');

            if (canvas) {
                canvas.style.marginTop = isFullScreen ? '30px' : '0px';
            }
        }

    }, [isFullScreen]);


    const dados = {
        labels,
        datasets: [
            {
                label: nomeDado,
                data: dadosGrafico,
                borderColor: corBordaDado ? corBordaDado : 'rgba(235, 135, 21, 1)',  // Modern border color
                backgroundColor: corBackgroundDado ? corBackgroundDado : 'rgba(89, 0, 255, 0.2)', // Modern background color
                tension: 0.3,  // Smooth curve for line chart
                fill: true,  // Fill area under the line
            },
        ],
    };

    const tooltip: _DeepPartialObject<TooltipOptions<"line">> = {
        enabled: true,
        mode: "point",
        callbacks: {
            title: () => {
                return tituloTooltip;
            },
            label: (data) => {
                setIndexData(data.dataIndex);
                return [dadoTooltip];
            },
        },
    };



    const [dashboardAberta, setDashboardAberta] = useState(true);
    return (
        <div className="grafico-linha-container">
            <div className="grafico-header" onClick={() => setDashboardAberta(!dashboardAberta)}>
                <h3>{tituloGrafico}</h3>
                <span>
                    {dashboardAberta ? <BsCaretUpFill className="arrow" /> : <BsCaretDownFill className="arrow" />}
                </span>
            </div>

            <AnimateHeight duration={500} height={dashboardAberta ? 'auto' : 0}>
                <button className="fullscreen-btn" onClick={() => setIsFullScreen(!isFullScreen)}>
                    {isFullScreen ? 'Fechar Tela Cheia' : 'Tela Cheia'}
                </button>

                {dadosGrafico.length ? (
                    <div ref={divRef} className={`grafico-container ${isFullScreen ? 'fullscreen' : ''}`}>
                        {isFullScreen && <button className="exit-fullscreen-btn" onClick={() => setIsFullScreen(false)}>X</button>}
                        <Line
                            options={{
                                scales: {
                                    y: {
                                        ticks: {
                                            callback: (value) => (graficoPorcentagem ? `${value} %` : value),
                                        },
                                    },
                                },
                                responsive: true,
                                plugins: {
                                    legend: { position: 'top' },
                                    tooltip: tooltip,
                                    title: { display: false, text: tituloGrafico },
                                },
                            }}
                            data={dados}
                        />
                    </div>
                ) : (
                    <MensagemGraficoVazio />
                )}
            </AnimateHeight>
        </div>
    );
};